import React from 'react';
import readingTime from 'reading-time';
import PostCard, { DIRECTION_ROW, DIRECTION_COLUMN } from './PostCard';
import Button from './Button';
import LocalizedLink from './LocalizedLink';
import FadeInSection from './FadeInSection';

const PostCardRoll = ({ headline, cta, posts, direction, displayLikes, displayDescription, className }) => {
  return (
    <div className={`flex flex-col justify-center ${className}`}>
      <h2 className="text-center">{headline}</h2>
      <div className="flex flex-col lg:flex-row lg:-ml-8">
        {posts.map(({ node: post }, i) => (
          <FadeInSection className={`flex flex-1 mb-12 lg:delay-${i * 300}`}>
            <LocalizedLink
              key={post.id}
              aria-label={`Link to ${post.title}`}
              title={`Link to ${post.title}`}
              className="no-underline w-full"
              to={`blog/${post.slug}`}
            >
              <PostCard
                title={post.title}
                description={post.description}
                featuredimage={post.featuredimage}
                likes={post.likes}
                views={post.views}
                direction={posts.length === 1 || direction === DIRECTION_ROW ? DIRECTION_ROW : DIRECTION_COLUMN}
                className="flex-1 lg:ml-8 h-full"
                timeToRead={Math.round(readingTime(post.body.text).minutes)}
                displayLikes={displayLikes}
                displayDescription={displayDescription}
              />
            </LocalizedLink>
          </FadeInSection>
        ))}
      </div>
      <div className="flex justify-center text-center">
        <Button to={cta.link} label={cta.label} className="w-full lg:w-1/3" />
      </div>
    </div>
  );
};

export default PostCardRoll;
